import { createContext } from 'react';

export type IComposableTabsContext = {
  activeTab?: string;
  onActiveTabChange?(activeTab: string): void;
  tabsId: string;
};

const ComposableTabsContext = createContext<IComposableTabsContext>({
  activeTab: undefined,
  tabsId: 'telia-components-tabs',
  onActiveTabChange: undefined,
});

export default ComposableTabsContext;
